/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGithub = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.198 1C6.014 1 1 6.014 1 12.2c0 4.947 3.208 9.145 7.66 10.626.56.102.764-.243.764-.54 0-.266-.01-.97-.015-1.905-3.116.677-3.773-1.501-3.773-1.501-.51-1.294-1.243-1.638-1.243-1.638-1.017-.695.077-.681.077-.681 1.124.08 1.715 1.154 1.715 1.154.999 1.711 2.62 1.217 3.26.931.101-.724.39-1.218.71-1.497-2.487-.283-5.101-1.244-5.101-5.535 0-1.223.436-2.222 1.153-3.005-.116-.284-.5-1.422.11-2.964 0 0 .94-.301 3.08 1.148a10.727 10.727 0 0 1 2.803-.378c.95.005 1.909.129 2.803.378 2.139-1.45 3.077-1.148 3.077-1.148.611 1.542.227 2.68.111 2.964.718.783 1.152 1.782 1.152 3.005 0 4.302-2.619 5.249-5.114 5.526.402.346.76 1.029.76 2.074 0 1.497-.013 2.705-.013 3.072 0 .3.201.648.77.539 4.446-1.485 7.652-5.68 7.652-10.625 0-6.186-5.014-11.2-11.2-11.2"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGithub as Github };
